import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';

let homeModule = angular.module('home', [
  uiRouter,
])

.config(($httpProvider, $stateProvider, $urlRouterProvider) => {
    "ngInject";
    $httpProvider.defaults.withCredentials = true;
    $urlRouterProvider.otherwise('/');
    $stateProvider
        .state('home', {
            resolve: {
                currentData: (LoadedModel) => {
                    return LoadedModel.getCurrentSession();
                },
            },
            url: '/',
            component: 'home'
        });
})

.component('home', homeComponent)

.name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js